"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Sidebar/List/Teams/Item.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _team = require('shared/selectors/team');
var _org = require('shared/selectors/org');



var _entities = require('shared/transforms/entities');
var _hooks = require('web/services/hooks');

var _GenericItem = require('web/screens/Directory/Sidebar/List/GenericItem'); var _GenericItem2 = _interopRequireDefault(_GenericItem);







const TeamItem = ({ teamKey, orgKey, isViewed }) => {
  const org = _hooks.useAppSelector.call(void 0, state => _org.selectOrgByKey.call(void 0, orgKey, state))
  const team = _hooks.useAppSelector.call(void 0, state => _team.selectTeamByKey.call(void 0, state, teamKey))
  const teamEntity = _react.useMemo.call(void 0, 
    () => {
      // SAFETY: the one key is orgKey, and its value is the org stored under it.
      const orgsMap = (org ? { [orgKey]: org } : {}) 
      return team
        ? _entities.mapTeamToEntity.call(void 0, 
          orgsMap,
          _entities.makeRawMembersCountTeamDescription,
        )(team)
        : null
    },
    [org, orgKey, team],
  )

  return (
    _react2.default.createElement(_GenericItem2.default, {
      entity: teamEntity,
      orgKey: orgKey,
      isViewed: isViewed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
    )
  )
}

exports. default = _react.memo.call(void 0, TeamItem)
